<div class="message-list">
  <div class="message-list__title">
    <h3>{{ viewModel?.title }}</h3>

    <div class="wrapper-link" *ngIf="viewModel?.messages?.length > viewModel?.quantityStartingItems">
      <a role="button" tabindex="0" (click)="toggleShowAllMessages()" *ngIf="!showAllMessages">
        Ver todas as mensagens
        <i class="icon icon--chevron-bottom icon--small"></i>
      </a>

      <a role="button" tabindex="0" (click)="toggleShowAllMessages()" *ngIf="showAllMessages">
        Ver menos
        <i class="icon icon--chevron-up icon--small"></i>
      </a>
    </div>
  </div>

  <div *ngIf="viewModel?.messages?.length; else emptyList">
    <div *ngFor="let item of viewModel?.messages | slice: 0 : quantityItems" class="message-list__content">
      <app-message-item [viewModel]="item" (clickItem)="clickAttachment($event)"></app-message-item>
    </div>
  </div>

  <ng-template #emptyList>
    <p class="message-list__empty">{{ viewModel?.emptyMessage }}</p>
  </ng-template>
</div>
